import { RouteObject } from "react-router-dom";
import {
  SETTINGS_MENU_PATH,
  SettingsMenuPage,
} from "@/modules/settings/pages/settings-menu";

export const settingsMenuRoutes: RouteObject[] = [
  {
    path: SETTINGS_MENU_PATH,
    element: <SettingsMenuPage />,
  },
];
